import * as  React from 'react';
import {Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography} from "@mui/material";
import {useDispatch} from 'react-redux';
import {
    addJambFirstChoice,
    addJambNumber,
    addJambSecondChoice,
    addJambSubjectScore,
    addTotalScore,
    appliedFirstJoice,
    appliedSecondJoice
} from '../../../redux/reducers/features/applicant-data/jamb-info-slice';
import {validateJambNumber} from '../../../utils/validateDataEntry';
import {excludeSelectedOptions} from '../../../utils/selectExclusion';


const jamb_subjects = [
    'English Language',
    'Mathematics',
    'Fine Arts',
    'Music',
    'French',
    'Animal Husbandry',
    'Insurance',
    'Chemistry',
    'Physics',
    'Yoruba',
    'Biology',
    'Geography',
    'Literature in English',
    'Economics',
    'Commerce',
    'Accounts - Principles of Accounts',
    'Government',
    'Igbo',
    'Christian Religious Knowledge (CRK)',
    'Agricultural Science',
    'Islamic Religious Knowledge (IRK)',
    'History',
    'Civic Education',
    'Further Mathematics',
    'Arabic',
    'Home Economics',
    'Hausa',
    'Book Keeping',
    'Data Processing',
    'Catering Craft Practice',
    'Computer Studies',
    'Marketing',
    'Physical Education',
    'Office Practice',
    'Fishery',
];
const faculties = [
    {
        id: 1,
        name: 'Education',
        departments: ['Education Management', 'Guidance and Cognitive Science', 'Primary Education', 'Library and Information Science']
    },
    {
        id: 2,
        name: 'Technical and Vocational Education',
        departments: ['Agriculture Education', 'Building Technology', 'Wood Work Technology',
            'Metal Work Technology', 'Automobile Technology', 'Electrical/Electronics Technology', 'Entrepreneurship Education']
    },
    {
        id: 3,
        name: 'Arts and Social Science Education',
        departments: ['Economics', 'Sustainable Development Studies', 'Islamic Studies', 'Christian Religious Studies',
            'English Education', 'Social Studies and Civic Education', 'History and International Studies']
    },
    {
        id: 4,
        name: 'Science Education',
        departments: ['Mathematics', 'Computer Science', 'Chemistry', 'Biology', 'Physics', 'Integrated Science', 'Human Kinetics and Health Education']
    }
];

// Faculty removed - flat department list (previously filtered by selected faculty) used directly instead
const allDepartments = [...new Set(faculties.flatMap(fac => fac.departments))];


function JambInfo({applicant}) {

    const dispatch = useDispatch();

    const [jambNumber, setJambNumber] = React.useState(applicant?.jamb_number), //required
        [jambTotalScore, setJambTotalScore] = React.useState(applicant?.jamb_total_score), //required
        [jambScoreOne, setJambScoreOne] = React.useState(applicant?.jamb_subject_scores[0]?.score),
        [jambScoreTwo, setJambScoreTwo] = React.useState(applicant?.jamb_subject_scores[1]?.score),
        [jambScoreThree, setJambScoreThree] = React.useState(applicant?.jamb_subject_scores[2]?.score),
        [jambScoreFour, setJambScoreFour] = React.useState(applicant?.jamb_subject_scores[3]?.score),
        [jambSubjectOne, setJambSubjectOne] = React.useState('English Language'),
        [jambSubjectTwo, setJambSubjectTwo] = React.useState(applicant?.jamb_subject_scores[1]?.subject),
        [jambSubjectThree, setJambSubjectThree] = React.useState(applicant?.jamb_subject_scores[2]?.subject),
        [jambSubjectFour, setJambSubjectFour] = React.useState(applicant?.jamb_subject_scores[3]?.subject),
        [firstChoiceUni, setFirstChoiceUni] = React.useState(applicant?.jamb_first_choice?.university),
        [firstChoicePoly, setFirstChoicePoly] = React.useState(applicant?.jamb_first_choice?.polytechnic),
        [firstChoiceCourse, setFirstChoiceCourse] = React.useState(applicant?.jamb_first_choice?.course),
        [secondChoiceUni, setSecondChoiceUni] = React.useState(applicant?.jamb_second_choice?.university),
        [secondChoicePoly, setSecondChoicePoly] = React.useState(applicant?.jamb_second_choice?.polytechnic),
        [secondChoiceCourse, setSecondChoiceCourse] = React.useState(applicant?.jamb_second_choice?.course),
        // [firstFaculty, setFirstFaculty] = React.useState(applicant?.applied_first_choice?.faculty), // Faculty removed
        [firstDepartment, setFirstDepartment] = React.useState(applicant?.applied_first_choice?.department),
        // [secondFaculty, setSecondFaculty] = React.useState(applicant?.applied_second_choice?.faculty), // Faculty removed
        [secondDepartment, setSecondDepartment] = React.useState(applicant?.applied_second_choice?.department)


    React.useEffect(() => {
        const jambFirstChoice = {

            university: firstChoiceUni,
            polytechnic: firstChoicePoly,
            course: firstChoiceCourse

        }

        const jambSecondChoice = {
            university: secondChoiceUni,
            polytechnic: secondChoicePoly,
            course: secondChoiceCourse
        }

        const appliedFirstChoice = {
            // faculty: firstFaculty, // Faculty removed
            department: firstDepartment
        }

        const appliedSecondChoice = {
            // faculty: secondFaculty, // Faculty removed
            department: secondDepartment
        }

        const jambSubjectScore = [
            {subject: jambSubjectOne, score: jambScoreOne},
            {subject: jambSubjectTwo, score: jambScoreTwo},
            {subject: jambSubjectThree, score: jambScoreThree},
            {subject: jambSubjectFour, score: jambScoreFour}
        ]

        dispatch(addJambNumber(jambNumber));
        dispatch(addTotalScore(jambTotalScore));
        dispatch(addJambFirstChoice(jambFirstChoice));
        dispatch(addJambSecondChoice(jambSecondChoice));
        dispatch(appliedFirstJoice(appliedFirstChoice));
        dispatch(appliedSecondJoice(appliedSecondChoice))
        dispatch(addJambSubjectScore(jambSubjectScore))

    }, [
        applicant,
        dispatch,
        firstChoiceCourse,
        firstChoicePoly,
        firstChoiceUni,
        firstDepartment,
        jambNumber,
        jambScoreFour,
        jambScoreOne,
        jambScoreThree,
        jambScoreTwo,
        jambSubjectFour,
        jambSubjectOne,
        jambSubjectThree,
        jambSubjectTwo,
        jambTotalScore,
        secondChoiceCourse,
        secondChoicePoly,
        secondChoiceUni,
        secondDepartment
    ])

    return (
        <Card sx={{p: {xs: 0, lg: 3}, mt: {xs: 1.8, lg: 3},width:'100%'}}>
            <CardContent>
                <Typography variant='h5' className='fw-bold'>JAMB Details</Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{mt: 3}} variant="outlined" fullWidth>
                            <TextField
                                label="JAMB Number"
                                placeholder="Enter JAMB Number"
                                variant="outlined"
                                value={jambNumber}
                                onChange={(e) => setJambNumber(e.target.value)}
                                error={!!(jambNumber && !validateJambNumber(jambNumber))}
                                helperText={jambNumber && !validateJambNumber(jambNumber) ? 'JAMB Number must be 12 digits followed by 2 letters' : ''}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{mt: 3}} variant="outlined" fullWidth>
                            <TextField
                                type={'number'}
                                label="JAMB Score"
                                placeholder='Select Score'
                                variant="outlined"
                                value={jambTotalScore}
                                onChange={(e) => setJambTotalScore(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Typography variant='body1' className='fw-bold mt-4 mt-lg-4'>JAMB Subjects and Scores</Typography>

                <Grid container spacing={2} sx={{mt: -1.0}}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{minWidth: '100%'}}>
                            <InputLabel id="demo-simple-select-autowidth-label">Select Subject</InputLabel>
                            <Select
                                value={jambSubjectOne}
                                onChange={(e) => setJambSubjectOne(e.target.value)}
                                fullWidth
                                disabled
                                label="Select Subject"
                            >
                                {
                                    jamb_subjects.map((subject, index) => (
                                        <MenuItem value={subject} key={Math.random() + '-' + index}>{subject}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                type={'number'}
                                label="Subject Score"
                                placeholder='Subject Score'
                                variant="outlined"
                                value={jambScoreOne}
                                onChange={(e) => setJambScoreOne(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{mt: 3.0}}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{minWidth: '100%'}}>
                            <InputLabel id="demo-simple-select-autowidth-label">Select Subject</InputLabel>
                            <Select
                                value={jambSubjectTwo}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setJambSubjectTwo(value);
                                    if (jambSubjectThree === value) setJambSubjectThree("");
                                    if (jambSubjectFour === value) setJambSubjectFour("");
                                }}
                                fullWidth
                                label="Select Subject"
                            >
                                {
                                    excludeSelectedOptions(jamb_subjects, jambSubjectTwo, [jambSubjectOne, jambSubjectThree, jambSubjectFour]).map((subject, index) => (
                                        <MenuItem value={subject} key={Math.random() + '-' + index}>{subject}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                type={'number'}
                                label="Subject Score"
                                placeholder='Subject Score'
                                variant="outlined"
                                value={jambScoreTwo}
                                onChange={(e) => setJambScoreTwo(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>


                <Grid container spacing={2} sx={{mt: 3.0}}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{minWidth: '100%'}}>
                            <InputLabel id="demo-simple-select-autowidth-label">Select Subject</InputLabel>
                            <Select
                                value={jambSubjectThree}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setJambSubjectThree(value);
                                    if (jambSubjectTwo === value) setJambSubjectTwo("");
                                    if (jambSubjectFour === value) setJambSubjectFour("");
                                }}
                                fullWidth
                                label="Select Subject"
                            >
                                {
                                    excludeSelectedOptions(jamb_subjects, jambSubjectThree, [jambSubjectOne, jambSubjectTwo, jambSubjectFour]).map((subject, index) => (
                                        <MenuItem value={subject} key={Math.random() + '-' + index}>{subject}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                type={'number'}
                                label="Subject Score"
                                placeholder='Subject Score'
                                variant="outlined"
                                value={jambScoreThree}
                                onChange={(e) => setJambScoreThree(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>


                <Grid container spacing={2} sx={{mt: 3.0}}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{minWidth: '100%'}}>
                            <InputLabel id="demo-simple-select-autowidth-label">Select Subject</InputLabel>
                            <Select
                                value={jambSubjectFour}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setJambSubjectFour(value);
                                    if (jambSubjectTwo === value) setJambSubjectTwo("");
                                    if (jambSubjectThree === value) setJambSubjectThree("");
                                }}
                                fullWidth
                                label="Select Subject"
                            >
                                {
                                    excludeSelectedOptions(jamb_subjects, jambSubjectFour, [jambSubjectOne, jambSubjectTwo, jambSubjectThree]).map((subject, index) => (
                                        <MenuItem value={subject} key={Math.random() + '-' + index}>{subject}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                type={'number'}
                                label="Subject Score"
                                placeholder='Subject Score'
                                variant="outlined"
                                value={jambScoreFour}
                                onChange={(e) => setJambScoreFour(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Typography variant='body1' className='fw-bold mt-4'>Institutions of choices as stated in your JAMB UTME
                    application form</Typography>

                <Grid container spacing={2} sx={{mt: -1.0}}>
                    <Grid item xs={12} lg={4}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                label="First Choice University"
                                placeholder="Enter Uni First Choice"
                                variant="outlined"
                                value={firstChoiceUni}
                                onChange={(e) => setFirstChoiceUni(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                label="First Choice Polytechnic"
                                placeholder='Enter Poly First Choice'
                                variant="outlined"
                                value={firstChoicePoly}
                                onChange={(e) => setFirstChoicePoly(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                label="First Choice Course"
                                placeholder='Enter First Choice Course'
                                variant="outlined"
                                value={firstChoiceCourse}
                                onChange={(e) => setFirstChoiceCourse(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{mt: 3}}>
                    <Grid item xs={12} lg={4}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                label="Second Choice University"
                                placeholder="Enter Uni Second Choice"
                                variant="outlined"
                                value={secondChoiceUni}
                                onChange={(e) => setSecondChoiceUni(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                label="Second Choice Polytechnic"
                                placeholder='Enter Poly Second Choice'
                                variant="outlined"
                                value={secondChoicePoly}
                                onChange={(e) => setSecondChoicePoly(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                label="Second Choice Course"
                                placeholder='Enter Second Choice Course'
                                variant="outlined"
                                value={secondChoiceCourse}
                                onChange={(e) => setSecondChoiceCourse(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Typography variant='body1' className='fw-bold mt-4 mt-lg-4'>Desired Department at
                    Maduka University, Minna</Typography>
                {/* Original heading: "Desired Department and Faculty at Maduka University, Minna" - Faculty removed */}

                <Grid container spacing={2} sx={{mt: -1.5}}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{mt: 1, minWidth: '100%'}}>
                            <InputLabel>Select First Choice Department</InputLabel>
                            <Select
                                value={firstDepartment}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFirstDepartment(value);
                                    if (secondDepartment === value) setSecondDepartment("");
                                }}
                                fullWidth
                                label="First Choice Department"
                            >
                                {
                                    excludeSelectedOptions(allDepartments, firstDepartment, [secondDepartment]).map((row, index) => (
                                        <MenuItem value={row} key={Math.random() + '-' + index}>{row}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{mt: 1, minWidth: '100%'}}>
                            <InputLabel>Select Second Choice Department</InputLabel>
                            <Select
                                value={secondDepartment}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSecondDepartment(value);
                                    if (firstDepartment === value) setFirstDepartment("");
                                }}
                                fullWidth
                                label="Second Choice Department"
                            >
                                {
                                    excludeSelectedOptions(allDepartments, secondDepartment, [firstDepartment]).map((row, index) => (
                                        <MenuItem value={row} key={Math.random() + '-' + index}>{row}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    {/* Faculty removed
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{mt: 1, minWidth: '100%'}}>
                            <InputLabel>Select First Choice Faculty</InputLabel>
                            <Select
                                value={firstFaculty}
                                onChange={(e) => setFirstFaculty(e.target.value)}
                                fullWidth
                                label="First Choice Faculty"
                            >
                                {
                                    faculties.map((row, index) => (
                                        <MenuItem value={row.name}
                                                  key={Math.random() + '-' + index}>{row.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{mt: 1, minWidth: '100%'}}>
                            <InputLabel>Select Second Choice Faculty</InputLabel>
                            <Select
                                value={secondFaculty}
                                onChange={(e) => setSecondFaculty(e.target.value)}
                                fullWidth
                                label="Second Choice Faculty"
                            >
                                {
                                    faculties.map((row, index) => (
                                        <MenuItem value={row.name}
                                                  key={Math.random() + '-' + index}>{row.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    */}
                </Grid>

            </CardContent>
        </Card>
    );
}

export default JambInfo;